<template>
  <div class="ProfileView container">
    <h1
      class="WelcomeView__heading flex items-center font-family-display font-weight-bold mb-48 flex"
    >
      <router-link
        :to="{ name: 'WelcomeView' }"
        class="color-black font-size-xxl mr-16"
      >
        <span class="icon-simple-arrow-left"></span>
      </router-link>
      {{ $t('profile') }}
    </h1>

    <div class="ProfileView__form-container">
      <EditProfileForm @edit-form-sent="profileFormEdited" />
    </div>
  </div>
</template>

<script setup>
import EditProfileForm from '@/components/forms/EditProfileForm.vue'
import { useNotificationsStore } from '@/stores/notificationsStore'
import { useI18n } from 'vue-i18n'

const { setNotification } = useNotificationsStore()
const { t } = useI18n()

function profileFormEdited() {
  setNotification({
    header: 'Success!! 🎉',
    body: t('profile_edited_successfully'),
    type: 'success'
  })
}
</script>

<style lang="scss" scoped>
.ProfileView {
  &__form-container {
    margin: auto;
    max-width: 100%;
    width: rem(588);
  }
}
</style>
